import { render, staticRenderFns } from "./DataUtilizacaoAplicativo.vue?vue&type=template&id=3d6eed9d"
import script from "./DataUtilizacaoAplicativo.vue?vue&type=script&lang=ts"
export * from "./DataUtilizacaoAplicativo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports